import { render, staticRenderFns } from "./doctor_examination.vue?vue&type=template&id=6065fe1f&scoped=true&"
import script from "./doctor_examination.vue?vue&type=script&lang=js&"
export * from "./doctor_examination.vue?vue&type=script&lang=js&"
import style0 from "./doctor_examination.vue?vue&type=style&index=0&id=6065fe1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065fe1f",
  null
  
)

export default component.exports